/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import Container from '@mui/material/Container';
import { Button } from '@mui/material';
import Fab from '@mui/material/Fab';
import { BrowserView } from 'react-device-detect';
import { useTranslation } from 'react-i18next';



const ContactUsSection = ( ) => {
   
  const { classes } = useStyles();
  const { t } = useTranslation()
    return (
        <>
            <main>
                <Grid item className={classes.container} xs={12} sm={12} md={12}>
                    <div className={classes.containerDotBG} >
                        <Container maxWidth="xl">
                            <Grid container spacing="4" >
                                <Grid item xs={12} sm={12} md={12}>

                                    <Grid container spacing="4" >
                                        <Grid item xs={12} sm={2} md={2} />

                                        <Grid item xs={12} sm={3} md={3}>
                                            <BrowserView>

                                                <Fab color="primary" aria-label="add" className='pulse' style={{ float: 'left' }}>
                                                    <img src="assets/images/icons/digitalmoney.png" alt="money" width="40px" />
                                                </Fab>
                                            </BrowserView>

                                        </Grid>
                                        <Grid item xs={12} sm={2} md={2} />

                                        <Grid item xs={12} sm={3} md={3}>
                                            <BrowserView>

                                                <Fab color="primary" aria-label="add" className='pulse' style={{ float: 'right' }}>
                                                    <img src="assets/images/icons/api.png" alt="money" width="40px" />
                                                </Fab>
                                            </BrowserView>

                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <Grid container spacing="4" >
                                        <Grid item xs={12} sm={3} md={3}>

                                            <Fab color="primary" aria-label="add" className='pulse' style={{ float: 'left' }}>
                                                <img src="assets/images/icons/infrastructure.png" alt="money" width="40px" />
                                            </Fab>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={6}>

                                            <Container className={classes.cardGrid} maxWidth="md">

                                                <Typography align="center" className={classes.bigHeaderTypo} gutterBottom>
                                                {t('descp:contactusDescpSection')}

                                                    
                                                </Typography>
                                                <Button variant='contained' href="mailto:info@belltane.com" className="alignCenter" style={{ width: '200px' }}>
                                                <Typography align="center"  >  {t('titles:contactus')}</Typography>

                                                </Button>
                                            </Container>
                                        </Grid>
                                        <Grid item xs={12} sm={3} md={3}>
                                            <BrowserView>
                                                <Fab color="primary" aria-label="add" className='pulse' style={{ float: 'right' }}>
                                                    <img src="assets/images/icons/chip.png" alt="money" width="40px" />
                                                </Fab>
                                            </BrowserView>
                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>


                                </Grid>
                            </Grid>
                        </Container>
                    </div>
                </Grid>
            </main>
        </>
    );
}

 
const useStyles = makeStyles({ "name": { ContactUsSection } })((theme) => ({
    root: {
        display: 'flex',
    },

    content: {
        flex: '1 0 auto',
    },


    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        margin: '10px',


        maxHeight: '400px!important',


        position: 'relative',
        zIndex: '9',
        display: 'flex',
        alignItems: 'center',
        height: '100vh',


        "&::before": {
            content: `''`,
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: -1,
            background: 'white'
        }
    },
    container: {

        margin: '50px',
        zIndex: '1',
        position: 'relative'
    },
    bigHeaderTypo: {

        fontSize: '22px!important',
        lineHeight: '1.2!important',
        marginBottom: '40px!important'
    },

    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    containerDotBG: {
        backgroundColor: '#fff!important',
        backgroundImage: 'radial-gradient(circle, #cbcbcb  20%, transparent 10%), radial-gradient(circle, #cbcbcb  20%, transparent 10%)',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 0, 50px 50px',
        padding: '50px'

    },
}));
export default ContactUsSection;